<template>
  <div class="workflow">
  <header-box :title="title" :intro="intro"></header-box>
    <div class="workflow__innerwrap">
      <div class="workflow__blocks">
        <div class="workflow__block" v-for="block in contentBlocks">

          <div class="workflow__block-image" v-if="(block.type === 'image' || block.type === 'image_text')">
            <movie-player v-if="block.video" class="workflow__block-video" :movieUrl="block.video" :placeholderUrl="block.image" autoplay="true"></movie-player>
            <img v-if="!block.video" :src="block.image" />
          </div>

          <div class="workflow__block-textwrap" v-if="(block.type === 'text' || block.type === 'image_text' || block.type === 'text_image')" :class="{'workflow__block-textwrap--long' : (block.type === 'text')}"> 
            <h2 class="workflow__block-title" v-html="block.title"></h2>
            <div class="workflow__block-content" v-html="block.content"></div>
          </div>

          <div class="workflow__block-image" v-if="(block.type === 'text_image')">
            <movie-player v-if="block.video" class="workflow__block-video" :movieUrl="block.video" :placeholderUrl="block.image" autoplay="true"></movie-player>
            <img v-if="!block.video" :src="block.image" />
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PrevNextNav from '@/components/PrevNextNav';
import HeaderBox from '@/components/HeaderBox';
import MoviePlayer from '@/components/MoviePlayer';

export default {
  name: 'workflow',
  components: { PrevNextNav, HeaderBox, MoviePlayer },
  computed: {
    ...mapGetters(['page']),
    title() {
      return this.page.title;
    },
    intro() {
      return this.page.intro;
    },
    contentBlocks() {
      return this.page.contentBlocks;
    },
  },
  mounted() {
    const vids = document.querySelectorAll('.workflow__block-video');

    [].forEach.call(vids, (vid) => {
      vid.addEventListener('ended', () => {
        vid.classList.add('hide');
      });
    });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '../../scss/helpers';

.workflow {
  @include page;
  background: none;

  &__blocks {
    box-sizing: border-box;
  }

  &__block {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    margin-bottom: 60px;

    @include landscape {
      flex-direction: row;
      margin-bottom: 40px
    }

    @include not-tablet {
      margin-bottom: 80px;
      flex-direction: row;
    }
  }

  &__block-image {
    display: block;
    position: relative;

    @include tablet {
      width: 75%;
      margin-right: 25%;
      order: 0;

      &:first-child:last-child {
        width: 100%;
        margin: 0;
      }
    }

    @include landscape {
      margin: 0;
      flex-basis: 0;
      flex-shrink: 1;
      flex-grow: 2;
      order: unset;
      width: auto;
    }

    @include not-tablet {
      flex-basis: 0;
      flex-shrink: 1;
      flex-grow: 2;
    }

    img {
      display: block;
      width: 100%;
    }

    // video + img {
    //   transition: opacity .5s;
    // }

    // video:not(.hide) + img {
    //   opacity: 0;
    // }
  }

  &__block-video {
    // width: 100%;
    // display: block;
    // position: absolute;
    // top: 0;
    // left: 0;
    // right: 0;
    // transition: opacity .5s;

    // &.hide {
    //   opacity: 0;
    //   pointer-events: none;
    // }
  }

  &__block-textwrap {
    box-sizing: border-box;
    background: $c_white;
    padding: 30px 20px 0;
    margin: auto;

    @include not-mobile {
      padding: 40px 0 0;
      width: 83.33%;
      margin-left: 16.66%;
    }


    @include not-laptop {
      order: 2;

      &:first-child:last-child {
        padding-top: 0;
      }
    }

    @include landscape {
      order: unset;
      padding: 0 20px 0 0;
      box-sizing: content-box;
      width: calc(50% - 10px);
      margin: 0;

      &--long {
        width: 75%;
        padding: 0 0 0 20px;
        box-sizing: border-box;
      }
    }

    @include not-tablet {
      width: calc(33.33% + 10px);
      padding: 0 40px 0 0;
      margin: 0;


      @include desktop {
        padding: 0 40px 0 7%;
      }

      &--long {
        width: 75%;
        max-width: 750px;
        padding: 0 0 0 40px;
        box-sizing: border-box;

        @include desktop {
          width: 66.66%;
        }
      }
    }
  }

  @include mobile {
    &__block:first-child &__block-textwrap:first-child:last-child {
      margin-top: 30px;
    }
  }

  @include not-tablet {
    &__block-image + &__block-textwrap {
      padding-right: 0;
      padding-left: 40px;

      @include desktop {
        padding-right: 7%;
        padding-left: 40px;
      }
    }
  }

  @include landscape {
    &__block-image + &__block-textwrap {
      padding-right: 0;
      padding-left: 20px;
    }
  }

  &__block-title {
    @include font-block-title;
  }

  &__block-content {
    @include font-block-content;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/templates/Workflow.vue